module.exports = __webpack_public_path__ + "static/media/group-5@3x.88083d70.png";